import Config from '../config';

const getS3AssetUrl = (assetPath: string) => `${Config.ASSET_URL}/${assetPath}`;

export default getS3AssetUrl;
